Ext.define('SA.view.color.ColorWindow', {
    extend: 'SA.view.SimpleContainer',

    statics: {
        onHide() {
            Ext.getDoc().un('mousedown', this.onMouseDown, this);

            Ext.callback(this.hideCallback, this.scope || this.instance);

            this.selectCallback = this.hideCallback = this.scope = null;
        },

        onMouseDown(ev) {
            if (!ev.getTarget('.sa-color-window', 100)) {
                this.instance.hide();
            }
        },

        onSelectColor(win, color) {
            Ext.callback(this.selectCallback, this.scope || win, [color]);
        },

        show(cfg) {
            cfg = cfg || {};

            var color = cfg.color,
                el = cfg.el,
                win = this.instance;

            if (typeof color !== 'string') {
                color = '000000';
            }

            if (win) {
                win.hide();
            }
            else {
                win = this.instance = new this();

                win.destroy = Ext.emptyFn;

                win.on({
                    hide: this.onHide,
                    'select:color': this.onSelectColor,

                    scope: this
                });
            }

            this.hideCallback = cfg.hide;
            this.selectCallback = cfg.select;
            this.scope = cfg.scope;

            win.setAllowTransparent(cfg.allowTransparent);

            if (el) {
                win.showBy(el, 'tl-bl?');
            }
            else {
                win.show();
            }

            win.setOriginalColor(color);

            Ext.getDoc().on('mousedown', this.onMouseDown, this);

            return win;
        }
    },

    autoShow: true,
    cls: 'sa-color-window',
    floating: true,
    height: 288,
    width: 276,
    window: true,

    items: [
        {
            xtype: 'simple-container',
            maxHeight: 27,
            padding: '27 0 0 0',

            items: [
                {
                    xtype: 'close-button',
                    closeAction: 'hide'
                }
            ]
        }, {
            xtype: 'simple-container',

            items: [
                {
                    xtype: 'simple-container',
                    height: 209,

                    items: [
                        {
                            xtype: 'palette-tab'
                        }, {
                            xtype: 'rgb-tab'
                        }, {
                            xtype: 'hsl-tab'
                        }
                    ],

                    listeners: {
                        'select:transparentColor': function() {
                            this.up('[window]').useColor('');
                        }
                    }
                }, {
                    xtype: 'component',
                    cls: 'sa-color-window-tabs-wrap',
                    itemId: 'tabList',

                    html: [
                        '<ul class="sa-color-window-tabs">',
                            '<li class="sa-color-window-tab sa-color-window-tab-active" data-tab="paletteTab">Palette</li>',
                            '<li class="sa-color-window-tab" data-tab="rgbTab">RGB</li>',
                            '<li class="sa-color-window-tab" data-tab="hslTab">HSL</li>',
                        '</ul>'
                    ],

                    listeners: {
                        el: {
                            delegate: '.sa-color-window-tab',

                            click(ev, target) {
                                Ext.getCmp(this.id).up('[window]').onTabClick(target);
                            },

                            mouseout(ev, target) {
                                Ext.fly(target).removeCls('sa-color-window-tab-over');
                            },

                            mouseover(ev, target) {
                                Ext.fly(target).addCls('sa-color-window-tab-over');
                            }
                        }
                    }
                }
            ]
        }
    ],

    initComponent() {
        this.callParent();

        this.paletteTab = this.activeTab = this.down('palette-tab');
        this.rgbTab = this.down('rgb-tab');
        this.hslTab = this.down('hsl-tab');

        this.fieldR = this.down('#fieldR');
        this.fieldG = this.down('#fieldG');
        this.fieldB = this.down('#fieldB');
        this.fieldH = this.down('#fieldH');
        this.fieldS = this.down('#fieldS');
        this.fieldL = this.down('#fieldL');

        this.fieldHex = this.down('hex-field');
        this.spectrum = this.down('spectrum');

        this.oldSwatches = this.query('color-swatch[swatchType=old]');
        this.newSwatches = this.query('color-swatch[swatchType=new]');

        this.recentRows = this.query('recent-row');
    },

    onTabClick(target) {
        var tabName = target.getAttribute('data-tab'),
            clickedTab = this[tabName];

        if (this.activeTab !== clickedTab) {
            this.activeTab = clickedTab;

            Ext.fly(this.el.query('.sa-color-window-tab-active')[0]).removeCls('sa-color-window-tab-active');
            Ext.fly(target).addCls('sa-color-window-tab-active');

            this.refresh();
        }
    },

    refresh() {
        var color = this.color,
            activeTab = this.activeTab;

        if (!color) {
            return;
        }

        Ext.suspendLayouts();

        [this.paletteTab, this.rgbTab, this.hslTab].forEach(tab => {
            tab.setVisible(tab === activeTab);
        });

        if (activeTab !== this.paletteTab) {
            this.newSwatches.forEach(swatch => {
                swatch.setColor(color);
            });

            this.oldSwatches.forEach(swatch => {
                swatch.setColor(this.originalColor);
            });

            if (activeTab === this.hslTab) {
                this.fieldH.setColor(color);
                this.fieldS.setColor(color);
                this.fieldL.setColor(color);

                this.spectrum.setColor(color);
            }

            if (activeTab === this.rgbTab) {
                this.fieldR.setColor(color);
                this.fieldG.setColor(color);
                this.fieldB.setColor(color);

                this.fieldHex.setColor(color);
            }
        }

        Ext.resumeLayouts(true);
    },

    setAllowTransparent(allow) {
        this.recentRows.forEach(row => {
            row.setAllowTransparent(allow);
        });
    },

    setColor(color) {
        this.color = color;

        this.refresh();
    },

    setOriginalColor(color) {
        if (color === '') {
            color = 'FFFFFF';
        }

        if (typeof color === 'string') {
            color = new SA.model.color.Color({color});
        }

        this.originalColor = color;

        this.setColor(color);
    },

    useColor(color) {
        if (color !== '') {
            color = color || this.color;

            this.recentRows.forEach(row => {
                row.addRecentColor(color);
            });

            color = color.getColor();
        }

        this.fireEvent('select:color', this, color);

        this.hide();
    }
});
